module.exports = __webpack_public_path__ + "static/cred_tech100.fbffa5ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/footer/cred_tech100.jpg
// module id = 1409
// module chunks = 168707334958949